import Vue from 'vue'
import Vuex from 'vuex'
import app from '../../main' // import the instance
import checkResponse from '@/utils/checkResponse'
import axios from 'axios'
import Crud from '../crud'
import moment from 'moment'
const model = (payload) => ({
  // columns
  id: payload.id,
  name: payload.name,
  purchase_order_id: payload.purchase_order_id,
  production_status_id: payload.production_status_id,
  production_area_id: payload.production_area_id,
  delivery_time: payload.delivery_time,
  delivery_date: moment(payload.delivery_date).format('YYYY-MM-DD'),
  without_process_date: moment(payload.without_process_date).format('YYYY-MM-DD'),
  in_progress_date: moment(payload.in_progress_date).format('YYYY-MM-DD'),
  stoped_date: moment(payload.stoped_date).format('YYYY-MM-DD'),
  forged_date: moment(payload.forged_date).format('YYYY-MM-DD'),
  fold_die_cut_date: moment(payload.fold_die_cut_date).format('YYYY-MM-DD'),
  enabled_date: moment(payload.enabled_date).format('YYYY-MM-DD'),
  paint_date: moment(payload.paint_date).format('YYYY-MM-DD'),
  finished_date: moment(payload.finished_date).format('YYYY-MM-DD'),
  destination: payload.destination,
  quantity: payload.quantity,
  unit_price: payload.unit_price
})
var crud = new Crud('CustomerPurchaseOrderDetails', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  customerPurchaseOrderDetails: [],
  catalog: {
    productionAreas: [],
    productionStatuses: []
  }
}

const mutations = {
  ...crud.mutations
}

const actions = {
  ...crud.actions,
  async loadDetails ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`customer-purchase-order-details?page=${payload.page}&purchase_order_id=${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_RECORDS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  }
}

const getters = {
  ...crud.getters,
  customerPurchaseOrderDetails: state => state.customerPurchaseOrderDetails
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
